export const mono = { fontFamily: "'Inter', ui-sans-serif, system-ui, sans-serif" };
export const dmMono = { fontFamily: '"DM Mono", monospace' };

export const labelStyle = {
  ...dmMono,
  fontSize: 8,
  color: 'rgba(255,255,255,0.38)',
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
};

export const sectionHeaderStyle = {
  ...dmMono,
  fontSize: 9,
  color: 'rgba(255,255,255,0.45)',
  textTransform: 'uppercase',
  letterSpacing: '0.1em',
};

export const textInputStyle = {
  width: '100%',
  minHeight: 32,
  borderRadius: 6,
  border: '1px solid rgba(255,255,255,0.14)',
  background: '#090909',
  color: 'white',
  padding: '6px 10px',
  ...dmMono,
  fontSize: 11,
  outline: 'none',
  boxSizing: 'border-box',
};

export const textAreaStyle = {
  ...textInputStyle,
  minHeight: 74,
  resize: 'vertical',
  lineHeight: 1.45,
};

export const secondaryButtonStyle = {
  height: 26,
  padding: '0 12px',
  borderRadius: 6,
  border: '1px solid rgba(255,255,255,0.12)',
  background: 'transparent',
  color: 'rgba(255,255,255,0.72)',
  ...dmMono,
  fontSize: 9,
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  cursor: 'pointer',
};

export const primaryButtonStyle = {
  ...secondaryButtonStyle,
  border: '1px solid rgba(255,255,255,0.18)',
  background: 'rgba(255,255,255,0.08)',
  color: 'white',
};

export const cardSurfaceStyle = {
  padding: '12px 14px',
  borderRadius: 8,
  border: '1px solid rgba(255,255,255,0.08)',
  background: 'rgba(255,255,255,0.02)',
};
